import axios from './http';
import { DignityResponse, TarmedDignityDto } from 'ts-types/api.types';

const {REACT_APP_API_BASE_URL: baseUrl} = process.env;
const apiUri = `${baseUrl}/api/dignities`;

export const getAllDignities = (): Promise<Array<TarmedDignityDto>> => {
  return axios.get<DignityResponse>(apiUri)
      .then(result => result.data.dignities);
};
